import { Injectable } from '@angular/core';
import { Http, RequestOptionsArgs, Headers } from '@angular/http';
import { Router } from '@angular/router';
//import { Observable } from 'rxjs/Observable';
import { Observable } from 'rxjs';
import { Config } from '../../config/config';
//import 'rxjs/add/operator/flatMap';


@Injectable()
export class VnptHttpService {

    constructor(private http: Http, private router: Router) {

    }
    get(url: string, option?: RequestOptionsArgs) {
        var router = this.router;
        var http = this.http;
        return http.get(url, option);
        /*
        return this.checkStillAuthenticated()
            .flatMap(function (uai) {
                return http.get(url, option);
                
                if (!uai.isAuthenticated){
                    router.navigate(['./login']);
                    return Observable.throw(new Error("Error"));
                }
                else
                    return http.get(url, option);
               
            });
         */
        
    }
    post(url: string, body: any, option?: RequestOptionsArgs) {
        var http = this.http;
        var router = this.router;
        return http.post(url, body, option);
        /*
        return this.checkStillAuthenticated()
            .flatMap(function (uai) {
                 //return http.post(url, body, option);
                
                if (!uai.isAuthenticated){
                    
                    router.navigate(['./login']);
                    return Observable.throw(new Error("Error"));
                    
                     return http.post(url, body, option);
                }
                else
                    return http.post(url, body, option);
                
            })
        */

    }

    checkStillAuthenticated() {
        var expires = localStorage.getItem("expires");
        if (!expires) {
            return Observable.of({ isAuthenticated: false });
        }
        else {
            let now = new Date();
            var expireDate = Date.parse(expires);
            if (now.getTime() - (new Date(expireDate)).getTime() < 0) {
                return Observable.of({ isAuthenticated: true });
            }
            else {
                return Observable.of({ isAuthenticated: false });
            }
        }
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/services/vnpt-http.service.ts